import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PersistConfig, persistReducer, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import persistStore from 'redux-persist/es/persistStore';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import { ApplicationState } from 'types/store';

import { middleware } from './middleware';
import rootReducer from './reducers';

const config: PersistConfig<ApplicationState> = {
  blacklist: ['audience', 'summary', 'user'],
  key: 'root',
  stateReconciler: autoMergeLevel2,
  storage: storage,
  version: 1,
};
const persistedReducer = persistReducer(config, rootReducer);
const store = configureStore({
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE],
      },
    }).concat([...middleware]);
  },
  reducer: persistedReducer,
});
const persistor = persistStore(store);

export { persistor, store };
